import { adultTeeth, childTeeth, teenageTeeth } from '../dentist/data/teethData';

export const getChartTitle = (chartType) => {
    switch (chartType) {
        case 'child': return 'Primary Teeth Chart';
        case 'teenage': return 'Mixed Dentition Chart';
        case 'adult':
        default: return 'Permanent Teeth Chart';
    }
};

export const getChartDescription = (chartType) => {
    switch (chartType) {
        case 'child': return `Primary dentition (${getTotalTeeth(chartType)} teeth) - Ages 6 months to 6 years`;
        case 'teenage': return `Mixed dentition (${getTotalTeeth(chartType)} teeth) - Ages 6 to 12 years`;
        case 'adult':
        default: return `Permanent dentition (${getTotalTeeth(chartType)} teeth) - Ages 12+ years`;
    }
};

export const getTeethData = (chartType) => {
    switch (chartType) {
        case 'child': return childTeeth;
        case 'teenage': return teenageTeeth;
        case 'adult':
        default: return adultTeeth;
    }
};

export const getTotalTeeth = (chartType) => {
    switch (chartType) {
        case 'child': return 20;
        case 'teenage': return 24;
        case 'adult':
        default: return 32;
    }
};

export const formatTo2Decimals = (value) => {
    const num = parseFloat(value);
    if (isNaN(num)) return 0;
    return Math.round((num + Number.EPSILON) * 100) / 100;
};

